  (function () {
    if (window.SJW_CUR) return;

    var CFG = window.SJW_CUR_CFG || {};

    // The amount token cannot live inside a Liquid output tag (it breaks the parser), so
    // the default for the amount-aware disclaimer is supplied here.
    if (!CFG.noteAmount) CFG.noteAmount = 'You\u2019ll be charged {amount} USD at checkout';

    /* ---------- known currencies (display list is gated by CFG.list) ---------- */
    /* locale drives Intl grouping/decimals; sym is a short label for the selector. */
    var CUR = {
      USD:{sym:'$',loc:'en-US'},   GBP:{sym:'£',loc:'en-GB'},   EUR:{sym:'€',loc:'de-DE'},
      CAD:{sym:'CA$',loc:'en-CA'}, AUD:{sym:'A$',loc:'en-AU'},  INR:{sym:'₹',loc:'en-IN'},
      AED:{sym:'AED',loc:'ar-AE'}, SGD:{sym:'S$',loc:'en-SG'},  JPY:{sym:'¥',loc:'ja-JP'},
      CHF:{sym:'CHF',loc:'de-CH'}, HKD:{sym:'HK$',loc:'en-HK'}, NZD:{sym:'NZ$',loc:'en-NZ'},
      SEK:{sym:'kr',loc:'sv-SE'},  NOK:{sym:'kr',loc:'nb-NO'},  DKK:{sym:'kr',loc:'da-DK'},
      ZAR:{sym:'R',loc:'en-ZA'},   SAR:{sym:'SAR',loc:'ar-SA'}, QAR:{sym:'QAR',loc:'ar-QA'},
      KWD:{sym:'KWD',loc:'ar-KW'}, MXN:{sym:'MX$',loc:'es-MX'}, BRL:{sym:'R$',loc:'pt-BR'},
      CNY:{sym:'CN¥',loc:'zh-CN'}, MYR:{sym:'RM',loc:'ms-MY'},  THB:{sym:'฿',loc:'th-TH'},
      IDR:{sym:'Rp',loc:'id-ID'},  PHP:{sym:'₱',loc:'en-PH'},   ILS:{sym:'₪',loc:'he-IL'},
      PLN:{sym:'zł',loc:'pl-PL'},  KRW:{sym:'₩',loc:'ko-KR'}
    };

    /* ---------- country → currency (only currencies in CFG.list are honoured) ---------- */
    var C2C = {
      US:'USD', GB:'GBP', IE:'EUR', DE:'EUR', FR:'EUR', ES:'EUR', IT:'EUR', NL:'EUR',
      BE:'EUR', AT:'EUR', PT:'EUR', FI:'EUR', GR:'EUR', LU:'EUR', CA:'CAD', AU:'AUD',
      IN:'INR', AE:'AED', SG:'SGD', JP:'JPY', CH:'CHF', HK:'HKD', NZ:'NZD', SE:'SEK',
      NO:'NOK', DK:'DKK', ZA:'ZAR', SA:'SAR', QA:'QAR', KW:'KWD', MX:'MXN', BR:'BRL',
      CN:'CNY', MY:'MYR', TH:'THB', ID:'IDR', PH:'PHP', IL:'ILS', PL:'PLN', KR:'KRW'
    };

    /* ---------- parse settings ---------- */
    function parseList(s) {
      var out = [], seen = {};
      String(s || '').toUpperCase().split(/[\s,]+/).forEach(function (c) {
        c = c.trim();
        if (c && CUR[c] && !seen[c]) { seen[c] = 1; out.push(c); }
      });
      if (out.indexOf('USD') < 0) out.unshift('USD');
      return out;
    }
    function parseRates(s) {
      var r = {};
      String(s || '').split(/[,\n]+/).forEach(function (pair) {
        var m = pair.split(':');
        if (m.length === 2) {
          var code = m[0].trim().toUpperCase(), v = parseFloat(m[1]);
          if (code && !isNaN(v) && v > 0) r[code] = v;
        }
      });
      return r;
    }

    var LIST = parseList(CFG.list);
    var MANUAL = parseRates(CFG.manualRates);
    var LS_CUR = 'sjw-cur', LS_RATES = 'sjw-cur-rates';

    var OUTMAP = {}, outN = 0;   // converted string -> USD cents (for the disclaimer)

    var state = {
      cur: 'USD',
      rates: { USD: 1 },
      ready: false
    };
    // seed manual rates immediately as a fallback so first paint has something
    for (var k in MANUAL) state.rates[k] = MANUAL[k];

    /* ---------- resolve the active currency ---------- */
    function stored() { try { return localStorage.getItem(LS_CUR); } catch (e) { return null; } }
    function allowed(c) { return c && LIST.indexOf(c) >= 0; }

    /* ---------- stats beacon (opt-in, off by default) ----------
       navigator.sendBeacon, never fetch and never an <img> pixel. Three reasons,
       in order of how badly each alternative would hurt:

         1. An <img> tracking pixel inserts a DOM node, and the MutationObserver
            further down reacts to ANY element insertion with a debounced
            full-document reprice. A pixel per currency decision would mean a
            full sweep per decision — that feedback loop is exactly what froze
            the whole site once already.
         2. sendBeacon does not block the main thread, does not delay unload, and
            the browser sends it when it likes. The shopper cannot perceive it.
         3. A text/plain body keeps the request CORS-simple, so there is no OPTIONS
            preflight. A JSON content-type would double the requests for nothing.

       Nothing is read from or written to the visitor's device here. The country
       comes from Cloudflare at the edge, so the payload is only a currency code
       and how it was decided. */
    var statsSent = false;

    function statsAllowed() {
      if (!CFG.stats) return false;
      if (!CFG.statsStrict) return true;
      // Strict mode honours the storefront's own consent banner. Deliberately
      // fails CLOSED — if the privacy API has not loaded yet we record nothing
      // rather than guessing that consent was given.
      try {
        var p = window.Shopify && window.Shopify.customerPrivacy;
        return !!(p && p.analyticsProcessingAllowed && p.analyticsProcessingAllowed());
      } catch (e) { return false; }
    }

    // Channel class only — never the referring URL, which can carry someone's search
    // terms and would turn a counter into data worth protecting.
    var REFCLASS = (function () {
      var r = '';
      try { r = document.referrer || ''; } catch (e) { return 'direct'; }
      if (!r) return 'direct';
      var h = '';
      try { h = new URL(r).hostname.toLowerCase(); } catch (e) { return 'direct'; }
      if (h === location.hostname || h.indexOf('signorajewels.com') > -1) return 'internal';
      if (/google|bing|yahoo|duckduckgo|baidu|yandex|ecosia|brave|search/.test(h)) return 'search';
      if (/facebook|instagram|pinterest|tiktok|twitter|linkedin|reddit|youtube|threads|snapchat|whatsapp|t\.co/.test(h)) return 'social';
      return 'ref';
    })();

    var PAGETYPE = CFG.pageType || 'other';

    function stat(cur, mode, step) {
      if (!statsAllowed() || !navigator.sendBeacon) return;
      try {
        navigator.sendBeacon(CFG.statsEndpoint, new Blob([JSON.stringify({
          c: cur, m: mode, p: PAGETYPE, r: REFCLASS, e: step || 'land'
        })], { type: 'text/plain' }));
      } catch (e) { /* analytics must never break the storefront */ }
    }

    /* ---------- add-to-cart, and tagging the cart with what they saw ----------
       The store has never completed an order, so add-to-cart is the only conversion
       signal that exists — "of the visitors shown GBP, how many reached the cart" is
       the closest thing to a verdict on whether local pricing earns its keep.

       Hooked through window.themeCore.EventBus, which is the same channel the
       theme's own cart-notification module listens on, rather than reaching into its
       PubSub internals. The bus may not exist yet when this runs, so binding is
       retried on a bounded schedule and then given up on. */
    var atcSent = false, cartCount = Number(CFG.cartCount) || 0, taggedCur = '';

    // Shopify copies cart attributes onto the order. Writing the displayed currency
    // there now means the very first order already carries it — this linkage cannot
    // be reconstructed later for orders that arrived without it. Leading underscore
    // keeps it out of customer-facing order emails while staying visible in admin.
    function tagCart(cur) {
      if (!CFG.stats || cur === taggedCur || cartCount < 1) return;
      taggedCur = cur;
      try {
        fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ attributes: { _display_currency: cur } })
        }).catch(function () {});
      } catch (e) {}
    }

    function onCartUpdated(payload) {
      var n = (payload && typeof payload.item_count === 'number') ? payload.item_count : null;
      if (n === null) {
        // The payload shape is not a contract, so ask the cart rather than assume.
        // Only runs on real cart activity, which is rare.
        try {
          fetch('/cart.js', { mode: 'same-origin' })
            .then(function (r) { return r.json(); })
            .then(function (c) {
              if (!c) return;
              if (c.item_count > cartCount && !atcSent) { atcSent = true; stat(state.cur, 'auto', 'atc'); }
              cartCount = Math.max(cartCount, c.item_count);
              tagCart(state.cur);
            })
            .catch(function () {});
        } catch (e) {}
        return;
      }
      if (n > cartCount && !atcSent) { atcSent = true; stat(state.cur, 'auto', 'atc'); }
      cartCount = Math.max(cartCount, n);
      tagCart(state.cur);
    }

    function bindCartBus() {
      try {
        var bus = window.themeCore && window.themeCore.EventBus;
        if (bus && typeof bus.listen === 'function') { bus.listen('cart:updated', onCartUpdated); return true; }
      } catch (e) {}
      return false;
    }
    if (!bindCartBus()) {
      var busTries = 0;
      var busIv = setInterval(function () {
        if (bindCartBus() || ++busTries > 20) clearInterval(busIv);
      }, 400);
    }

    // The one "how did this visit start" event. Guarded because the currency can be
    // settled by three different paths and boot() re-dispatches its own event after
    // live rates land — without this guard every non-USD pageview double-counts.
    function statLanding(cur, mode) {
      if (statsSent) return;
      statsSent = true;
      stat(cur, mode);
    }

    state.cur = allowed(stored()) ? stored() : 'USD';

    // A returning visitor restoring a stored choice is a bare assignment above that
    // fires no event at all, so it is invisible to anything listening on
    // sjw:currency — and it is precisely the segment worth measuring. Instrument it
    // here, at the decision, not through the event.
    if (allowed(stored())) statLanding(state.cur, 'restore');

    /* ---------- rounding ---------- */
    function roundVal(v) {
      switch (CFG.rounding) {
        case 'end99': return Math.max(0, Math.round(v) - 0.01);
        case 'near1': return Math.round(v);
        case 'near5': return Math.round(v / 5) * 5;
        case 'near10': return Math.round(v / 10) * 10;
        default: return v;
      }
    }

    /* ---------- format cents (USD base) into the active currency ---------- */
    // Deliberately NOT Intl currency formatting: native locales confuse an
    // English storefront (de-DE renders EUR as "1.808 €" — reads as 1.8; en-CA
    // renders CAD as a bare "$" — reads as USD). Instead: every currency keeps
    // its own unambiguous prefix (CA$/A$/€/₹…) + English-style grouping.
    // INR alone groups en-IN (₹2,52,000) — that's what Indian shoppers expect.
    function fmtNum(v, cur) {
      var noDec = (CFG.rounding !== 'none' && CFG.rounding !== 'end99') || cur === 'JPY' || cur === 'KRW';
      return v.toLocaleString(cur === 'INR' ? 'en-IN' : 'en-US', {
        minimumFractionDigits: noDec ? 0 : 2, maximumFractionDigits: noDec ? 0 : 2
      });
    }

    function money(cents) {
      cents = Number(cents) || 0;
      var cur = state.cur;
      if (cur === 'USD' || !CFG.on) {
        // native USD formatting (matches the store's USD amount format)
        var u = cents / 100;
        return '$' + u.toLocaleString('en-US', {
          minimumFractionDigits: (cents % 100 ? 2 : 0), maximumFractionDigits: 2
        });
      }
      var rate = state.rates[cur] || MANUAL[cur] || 1;
      var val = roundVal((cents / 100) * rate);
      var num = fmtNum(val, cur);
      var out;
      if (CFG.symbolStyle === 'code') out = num + ' ' + cur;
      else {
        var sym = (CUR[cur] || {}).sym || cur;
        // letter symbols (AED, CHF, kr…) read better with a space before the number
        out = /[A-Za-z]$/.test(sym) ? sym + ' ' + num : sym + num;
        if (CFG.symbolStyle === 'both') out += ' ' + cur;
      }
      // Remember what this converted string was worth in USD, so the disclaimer
      // can quote the real charge (owner call: "USD ki value toh dikha sakte hai").
      OUTMAP[out] = cents;
      if (++outN > 400) { OUTMAP = {}; outN = 0; }
      return out;
    }

    function usdStr(cents) {
      var u = cents / 100;
      return '$' + u.toLocaleString('en-US', {
        minimumFractionDigits: (cents % 100 ? 2 : 0), maximumFractionDigits: 2
      });
    }

    // The USD figure behind a converted element: either the original string we
    // stashed when repricing the DOM, or a reverse lookup for prices the PDP
    // rendered through money().
    function anchorUSD(el) {
      if (!el) return null;
      var w = document.createTreeWalker(el, NodeFilter.SHOW_TEXT, null), n;
      while ((n = w.nextNode())) {
        if (n.__sjwUsd) {
          var m = String(n.__sjwUsd).match(/\$\s*[\d,]+(?:\.\d{1,2})?/);
          if (m) return m[0].replace(/\s+/g, '');
        }
      }
      var t = (el.textContent || '').trim();
      if (OUTMAP[t] != null) return usdStr(OUTMAP[t]);
      return null;
    }

    /* ---------- reprice the DOM ---------- */
    /* Curated money-bearing selectors. We capture the base USD once (data-sjw-usdc,
       in cents) so switching currency later re-renders from truth, never from a
       previously-converted string. */
    /* NOTE: the PDP's own price nodes (.sjwpp-price, .sb-price, .sjw-jm-price, …)
       are variant-driven and rendered by the PDP JS through money() — which is
       hooked to this engine. They intentionally stay OUT of this list, else a
       frozen base-cents capture would fight the PDP on variant changes. */
    var SELECTORS = [
      '.product-card__price', '.product-card-mini__price',
      '.price-item', '.price__regular .price-item', '.price__sale .price-item',
      '.cart-item__price', '.cart-item__price--new', '.cart-item__price--old',
      '.cart-item-drawer__price', '.cart-item-drawer__price--new', '.cart-item-drawer__price--old',
      '.cart-footer__subtotal-value', '.cart-template__total', '.cart-upsell__item-price',
      '[data-sjw-usdc]',
      /* cart satellites: add-to-cart popup, free-shipping bar, savings, unit price */
      '.cart-notification-item__price', '.cart-notification-summary__value',
      '.js-cart-shipping-amount-msg', '.cart-footer__savings', '.unit-price',
      '.product-volume-pricing__list-item',
      /* quick view + wishlist */
      '.sjwqv .priceline .price', '.sjw-sv-item .dpr', '#sjw-sv-sub',
      /* loose-diamond cards on collection pages + the finder rail */
      '.sjw-dia-price', '.sjw-dia-det-price', '.sjw-dia-det-ppc', '.sjw-fc-p',
      /* PDP satellite: sale strike-through. The Diamond Guide owns its dynamic
         nodes through SJW_CUR.money(), so sweeping them here would convert an
         already-localized A$/CA$ string a second time. */
      '.sjw-sale-was',
      /* Loose-diamonds search (#sjw-dx2) + diamond product page — their section
         files stay UNTOUCHED (owner's work); the engine reprices from outside.
         Result cards render dynamically; the MutationObserver picks them up.
         The price FILTER slider intentionally stays USD (it drives the API query). */
      '#sjw-dx2 .dxprice', '#sjw-dx2 .dprice', '#sjw-dx2 .dpprice',
      '#sjw-dx2 .dxcmpm-price', '#sjw-dx2 .dxcmp2-price',
      /* detail view: mobile buy bar + the inquiry ("check availability") modal —
         both render their own money() string, so they need repricing too. */
      '.dp-mobile-bar b', '#sjwInqStone', '.dxinq-stone',
      /* table/list view, per-carat columns, compare modal, detail drawer, rails */
      '#sjw-dx2 .dxctable .pr', '#sjw-dx2 .ppccell', '#sjw-dx2 .ppc',
      '#sjw-dx2 .dxcmp2-ppc', '#sjwCompareBody', '#sjwDbody .drow b',
      '#sjw-dx2 .sjwrc i',
      /* diamond product page + its similar-stones rail */
      '.sjw-dpdp-price', '.sjw-dsim-foot .pr'
    ];

    var USD_TOKEN = /\$\s*([\d,]+(?:\.\d{1,2})?)/g;

    // Convert every "$1,234.56" token inside a string, preserving surrounding
    // words ("From ", " USD", ranges "$A - $B").
    function convStr(usd) {
      var out = String(usd).replace(USD_TOKEN, function (whole, num) {
        var cents = Math.round(parseFloat(num.replace(/,/g, '')) * 100);
        return isNaN(cents) ? whole : money(cents);
      });
      // Some theme snippets hardcode `| money_with_currency`, which renders
      // "$1,234.00 USD". After conversion that would read "€1,150 USD" — strip
      // the stale code so the symbol alone carries the currency.
      if (state.cur !== 'USD') out = out.replace(/(\d)\s+USD\b/g, '$1');
      return out;
    }

    function repriceEl(el) {
      // reprice at the TEXT-NODE level so wrappers (sale+regular+hidden labels)
      // never get flattened. Each text node stashes its original USD once.
      var w = document.createTreeWalker(el, NodeFilter.SHOW_TEXT, null);
      var node;
      while ((node = w.nextNode())) {
        if (node.__sjwUsd == null) {
          if (!/\$\s*[\d,]/.test(node.nodeValue)) continue;   // no USD amount
          node.__sjwUsd = node.nodeValue;
        }
        var t = convStr(node.__sjwUsd);
        if (node.nodeValue !== t) node.nodeValue = t;
      }
    }

    // everFx: has a non-USD currency ever been active this pageview? While the
    // visitor is on plain USD (the default), reprice work is a no-op — keep it
    // near-zero cost and, critically, MUTATION-FREE (see the observer notes).
    var everFx = false;

    function repriceAll(root) {
      if (!CFG.on) return;
      if (state.cur === 'USD' && !everFx) { toggleNote(); return; }
      root = root || document;
      // Skip cart surfaces when the owner opted out
      var skipCart = !CFG.convertCart;
      SELECTORS.forEach(function (sel) {
        var nodes = root.querySelectorAll(sel);
        for (var i = 0; i < nodes.length; i++) {
          var el = nodes[i];
          if (skipCart && el.closest('.cart, .cart-drawer, [class*="cart-item"], [class*="cart-footer"]')) continue;
          repriceEl(el);
        }
      });
      toggleNote();
    }

    /* ---------- the "approximate — charged in USD" note ---------- */
    // Auto-place a note AFTER the price row (not inside it, so flex layouts
    // never break). Anchors: the PDP price + cart totals. Any element the theme
    // marks with [data-sjw-cur-note] is honoured too.
    // Only injects while a non-USD currency is active — on the default USD view
    // the engine must not create DOM nodes at all.
    function injectNotes() {
      if (!CFG.note || state.cur === 'USD') return;
      var anchors = document.querySelectorAll('[data-sjwpp-price], .cart-footer__subtotal-value');
      for (var i = 0; i < anchors.length; i++) {
        var row = anchors[i].parentNode;
        if (!row || !row.parentNode) continue;
        var nxt = row.nextSibling;
        if (nxt && nxt.nodeType === 1 && nxt.hasAttribute && nxt.hasAttribute('data-sjw-cur-note')) continue;
        var n = document.createElement('div');
        n.setAttribute('data-sjw-cur-note', '');
        // PDP buybox: the note reads as a tab hanging off the card's bottom edge
        // (owner call 2026-07-29) — everywhere else it stays an inline chip.
        if (anchors[i].closest('.sjwpp-card, .sjwpp-gcol')) n.className = 'sjw-cur-note--tab';
        n.__sjwAnchor = anchors[i];
        row.parentNode.insertBefore(n, row.nextSibling);
      }
    }

    function toggleNote() {
      var show = CFG.on && state.cur !== 'USD' && CFG.note;
      document.querySelectorAll('[data-sjw-cur-note]').forEach(function (n) {
        var want = '';
        if (show) {
          var usd = anchorUSD(n.__sjwAnchor);
          // an empty cart's subtotal is $0 — no point disclaiming nothing
          if (usd && /^\$0(\.00)?$/.test(usd)) usd = null, want = '';
          else want = (usd && CFG.noteAmount) ? CFG.noteAmount.replace('{amount}', usd) : CFG.note;
        }
        var disp = show ? 'block' : 'none';
        if (n.textContent !== want) n.textContent = want;   // write only on change —
        if (n.style.display !== disp) n.style.display = disp; // avoids mutation churn
      });
      if (document.documentElement.getAttribute('data-sjw-cur') !== state.cur) {
        document.documentElement.setAttribute('data-sjw-cur', state.cur);
      }
    }

    /* ---------- rates: cache → live → manual ---------- */
    function loadCachedRates() {
      try {
        var raw = JSON.parse(localStorage.getItem(LS_RATES) || 'null');
        if (raw && raw.rates && (Date.now() - raw.ts) < 12 * 3600 * 1000) {
          for (var c in raw.rates) state.rates[c] = raw.rates[c];
          return true;
        }
      } catch (e) {}
      return false;
    }
    function fetchLiveRates() {
      if (CFG.rateSource !== 'live' || !window.fetch) return Promise.resolve(false);
      return fetch(CFG.liveEndpoint, { mode: 'cors' })
        .then(function (r) { return r.json(); })
        .then(function (j) {
          if (!j || !j.rates) return false;
          var keep = {};
          LIST.forEach(function (c) { if (j.rates[c]) keep[c] = j.rates[c]; });
          keep.USD = 1;
          for (var c in keep) state.rates[c] = keep[c];
          try { localStorage.setItem(LS_RATES, JSON.stringify({ ts: Date.now(), rates: keep })); } catch (e) {}
          return true;
        })
        .catch(function () { return false; });
    }

    /* ---------- geo default (Cloudflare, same-origin) ---------- */
    // Every early exit below leaves the visitor on USD, and each one means something
    // different: no auto-detect configured, the trace was blocked, the country is on
    // the exclude list, or we simply offer nothing local for that country. All four
    // report as 'default' — which is what makes the admin panel's "markets with no
    // local currency" list possible. Without stamping the no-op paths, a US or
    // Indian visitor would produce no signal at all, because setCurrency is never
    // reached for them.
    function geoDefault() {
      if (!CFG.auto || stored() || !window.fetch) {
        if (!stored()) statLanding(state.cur, 'default');
        return Promise.resolve();
      }
      return fetch('/cdn-cgi/trace', { mode: 'same-origin' })
        .then(function (r) { return r.text(); })
        .then(function (t) {
          var m = t.match(/loc=([A-Z]{2})/);
          if (!m) { statLanding(state.cur, 'default'); return; }
          // owner call 2026-07-29: excluded countries (default India) start in
          // USD — the visitor can still pick their currency manually.
          var excl = String(CFG.geoExclude || '').toUpperCase().split(/[\s,]+/);
          if (excl.indexOf(m[1]) >= 0) { statLanding(state.cur, 'default'); return; }
          var cur = C2C[m[1]];
          if (allowed(cur) && cur !== state.cur) { setCurrency(cur, false); }
          else statLanding(state.cur, 'default');
        })
        .catch(function () { statLanding(state.cur, 'default'); });
    }

    /* ---------- public API ---------- */
    function setCurrency(cur, persist) {
      if (!allowed(cur)) return;
      // `persist` is the only reliable way to tell a shopper's own choice from a geo
      // guess: the selector passes true, geoDefault passes false, and the
      // sjw:currency event carries neither. A manual switch is recorded EVERY time —
      // someone trying three currencies is three real data points — while a geo
      // guess is a landing fact and so goes through the once-per-page guard.
      // 'switch', not 'land': a shopper changing currency mid-visit is a real data
      // point for cur_daily, but it is NOT a second visit. Sending 'land' here would
      // add a row to the funnel denominator and understate every add-to-cart rate.
      if (persist) { stat(cur, 'manual', 'switch'); tagCart(cur); }
      else statLanding(cur, 'auto');
      state.cur = cur;
      if (cur !== 'USD') everFx = true;
      if (persist) { try { localStorage.setItem(LS_CUR, cur); } catch (e) {} }
      injectNotes();
      repriceAll();
      syncSelectors();
      document.dispatchEvent(new CustomEvent('sjw:currency', { detail: { currency: cur, rate: state.rates[cur] || 1 } }));
      // The PDP re-renders its price inside that event, so the exact USD figure only
      // becomes resolvable a tick later — re-run the note or it falls back to the
      // generic wording on every manual switch.
      setTimeout(toggleNote, 0);
    }

    function syncSelectors() {
      document.querySelectorAll('[data-sjw-cur-select]').forEach(function (sel) {
        if (sel.value !== state.cur) sel.value = state.cur;
      });
      document.querySelectorAll('[data-sjw-cur-code]').forEach(function (n) { n.textContent = state.cur; });
    }

    window.SJW_CUR = {
      on: CFG.on, cfg: CFG, list: LIST, meta: CUR, state: state,
      money: money, reprice: repriceAll, set: setCurrency, sync: syncSelectors
    };

    /* ---------- boot ---------- */
    loadCachedRates();

    // Observer discipline (the first release froze the page here):
    //  1. moBusy guard + takeRecords() — our own DOM writes (notes, price text)
    //     must never re-trigger us.
    //  2. Element filter — react only to real element insertions that aren't our
    //     own [data-sjw-cur-note] nodes; pure text mutations are ignored.
    //  3. 150ms debounce — slideshow/chat widgets mutate constantly; we coalesce.
    //  4. While USD is displayed (everFx false) reprice is a no-op anyway.
    var mo = null, moBusy = false, moTimer = 0;

    function guardedSweep() {
      moBusy = true;
      try { injectNotes(); repriceAll(); } catch (e) {}
      if (mo) mo.takeRecords();   // flush records our own writes just produced
      moBusy = false;
    }

    function boot() {
      guardedSweep();
      mo = new MutationObserver(function (muts) {
        if (moBusy) return;
        var need = false;
        for (var i = 0; i < muts.length && !need; i++) {
          var added = muts[i].addedNodes;
          if (!added) continue;
          for (var j = 0; j < added.length; j++) {
            var n = added[j];
            if (n.nodeType !== 1) continue;                                   // text nodes: ours
            if (n.hasAttribute && n.hasAttribute('data-sjw-cur-note')) continue; // ours
            need = true; break;
          }
        }
        if (!need) return;
        clearTimeout(moTimer);
        moTimer = setTimeout(guardedSweep, 150);
      });
      try { mo.observe(document.body, { childList: true, subtree: true }); } catch (e) {}

      fetchLiveRates().then(function (ok) {
        if (!ok) return;
        guardedSweep();
        // PDP price is engine-hooked but not in the DOM repricer — nudge it so it
        // reflects the accurate (not fallback) rate.
        if (state.cur !== 'USD') document.dispatchEvent(new CustomEvent('sjw:currency', { detail: { currency: state.cur, rate: state.rates[state.cur] || 1 } }));
      });
      geoDefault();
      syncSelectors();
    }

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
    else boot();
    document.addEventListener('shopify:section:load', function () { guardedSweep(); });
  })();
